// extracted by mini-css-extract-plugin
export var container = "_1u-0";
export var disabled = "_1u-4";
export var fullWidth = "_1u-3";
export var lined = "_1u-1";
export var selected = "_1u-5";
export var tab = "_1u-2";